import type { TournamentStatus } from "../types/domain";

interface Props {
  status: TournamentStatus;
}

const STATUS_CLASSES: Record<TournamentStatus, string> = {
  draft: "bg-gray-100 text-gray-600",
  registration_open: "bg-emerald-100 text-emerald-700",
  registration_closed: "bg-amber-100 text-amber-700",
  in_progress: "bg-emerald-100 text-emerald-700",
  finished: "bg-gray-100 text-gray-600",
  cancelled: "bg-gray-100 text-gray-600",
};

export function TournamentStatusPill({ status }: Props) {
  return (
    <span className={`status-pill ${STATUS_CLASSES[status]}`}>
      {tournamentStatusLabel(status)}
    </span>
  );
}

function tournamentStatusLabel(status: TournamentStatus): string {
  switch (status) {
    case "draft":
      return "Brouillon";
    case "registration_open":
      return "Inscriptions ouvertes";
    case "registration_closed":
      return "Inscriptions closes";
    case "in_progress":
      return "En cours";
    case "finished":
      return "Terminé";
    case "cancelled":
      return "Annulé";
    default:
      return status;
  }
}
